// extracted by mini-css-extract-plugin
export default {"leadDetailsBlock":"styles_leadDetailsBlock__z0-3A","blockWrapper":"styles_blockWrapper__ogcyh","label":"styles_label__z0oC0","value":"styles_value__al+QV"};